import { Observable } from 'rxjs';
import { RequestSigInt } from '../../signatureIntegrity/request-signature-integrity';
import { ResponseSigInt } from '../../signatureIntegrity/response-signature-integrity';

export abstract class SignatureIntegrityGateway {
    abstract getSigInt(data: RequestSigInt): Observable<ResponseSigInt>;
}